import React from "react";
import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { OrderApi } from "../../../../../../../../../../../services/Api/Organization/types";
import OrderItemsCardTable from "./OrderItemsCardTable";

interface Props {
	fileImportPreviewMode?: boolean;
	importedOrder?: OrderApi;
}

const OrderItemsCard = ({ fileImportPreviewMode, importedOrder }: Props) => {
	const { t } = useTranslation();

	return (
		<Card className="card-box positions-card">
			<Card.Body>
				<h5 className="card-title">{t("common.word.items")}</h5>
				<OrderItemsCardTable fileImportPreviewMode={fileImportPreviewMode} importedOrder={importedOrder} />
			</Card.Body>
		</Card>
	);
};

export default OrderItemsCard;
